module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "products-type"
  }, [_c('div', {
    staticClass: "showValue",
    on: {
      "click": _vm.openSelectBox
    }
  }, [_c('span', {
    staticClass: "wordSpan"
  }, [_vm._v(_vm._s(_vm.categories.name))]), _vm._v(" "), _c('span', {
    staticClass: "iconBox",
    class: [_vm.isShowSelectBox ? 'el-icon-caret-top' : 'el-icon-caret-bottom']
  })]), _vm._v(" "), (_vm.isShowSelectBox) ? _c('div', {
    staticClass: "selectBox"
  }, [_c('div', {
    staticClass: "top"
  }, _vm._l((_vm.routerArray), function(router, index) {
    return _c('span', {
      class: {
        'pre': index !== _vm.routerArray.length - 1
      },
      on: {
        "click": function($event) {
          _vm.getCategories(router.id)
        }
      }
    }, [_vm._v(" " + _vm._s(index !== 0 ? '>' : '') + " " + _vm._s(router.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.categoryList.length === 0) ? _c('span', {
    staticClass: "empty"
  }, [_vm._v("该分类下暂无子分类")]) : _c('el-radio-group', {
    on: {
      "change": _vm.changeCategory
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, _vm._l((_vm.categoryList), function(category) {
    return _c('el-radio', {
      key: category.id,
      attrs: {
        "label": category
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.getCategories(category.id)
        }
      }
    }, [_vm._v(_vm._s(category.name))])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.allCategories
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('div', {
    staticClass: "bottomBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isShowSelectBox = false
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.hide('abolish')
      }
    }
  }, [_vm._v("取消")])], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145c6602","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/products-type.vue
// module id = 1219
// module chunks = 82